<template>
  <div class="main-container">
    <div class="card-area">
      <el-card>
        <div class="card-head title">
          <span>赤峰市公务员平时考核系统</span>
        </div>
        <div class="card-body">
          <el-row>
            <el-col :span="12">
              <el-image
                draggable="false"
                style="width: 80%"
                :src="require('../assets/bg.png')"
                :fit="fit"
              ></el-image>
            </el-col>
            <el-col :span="12">
              <div class="login-form">
                <el-form :model="loginForm" :rules="rules">
                  <div class="sub-title title">
                    <span>- 欢迎登录 -</span>
                  </div>
                  <el-form-item prop="username">
                    <el-input
                      class="center-item"
                      v-model="loginForm.username"
                      placeholder="请输入用户名"
                    >
                      <template #prepend
                        ><el-icon><user /></el-icon></template
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      class="center-item"
                      v-model="loginForm.password"
                      show-password
                      placeholder="请输入密码"
                    >
                      <template #prepend
                        ><el-icon><key /></el-icon></template
                    ></el-input>
                  </el-form-item>

                  <el-button class="submit-btn" type="primary" @click="onLogin"
                    >登录</el-button
                  >
                </el-form>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
  <el-affix position="bottom" class="bottom-text">
    <!-- <p>{{ numberPhone }}</p>
    <p v-text="company"></p> -->
    <span class="end-text">公司：{{ company }}</span>
    <span class="end-text">联系电话：{{ numberPhone }}</span>
    <span class="end-text">联系QQ：{{ numberQQ }}</span>
    <span class="end-text"><a href="https://beian.miit.gov.cn/">蒙ICP备2022003970号</a></span>
    
  </el-affix>
</template>

<script>
import { User, Key } from "@element-plus/icons";
import { getUserInfo } from "../api/Login";
import { sha256 } from "js-sha256";
// import { numberQQ, numberPhone, company } from "../utils/utilData";
import { post } from "../utils/request";

export default {
  data() {
    return {
      loginForm: {
        username: "10000",
        password: "",
      },
      numberQQ: "",
      numberPhone: "",
      company: "",
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  name: "Login",
  methods: {
    onLogin() {
      let data = {
        username: this.loginForm.username,
        password: sha256(this.loginForm.password),
      };
      // let data = JSON.stringify(this.loginForm);
      getUserInfo(JSON.stringify(data));
    },
    searchSysParam() {
      post("/sysparam/search").then((res) => {
        if (res.code == 200) {
          let data = JSON.parse(res.data.data);
          this.numberQQ = data.numberQQ;
          this.numberPhone = data.numberPhone;
          this.company = data.company;
        }
      });
    },
  },
  components: { User, Key },
  created() {
    this.searchSysParam();
  },
};
</script>

<style scoped lang="scss">
.main-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../assets/bg0.jpg");
  height: 100%;
}

.card-area {
  width: 60%;
  height: 60%;
}

.card-head {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 40px;
}

.form-area {
  justify-content: center;
  align-items: center;
}

.submit-btn {
  margin-top: 40px;
  width: 70%;
}

.title {
  color: rgb(22, 98, 197);
}

.sub-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 40px;
}

.foot {
  display: flex;
  justify-content: center;
  text-align: end;
}

.bottom-text {
  color: white;
  margin-bottom: 20px;
}

.login-form {
  // width: 80%;
  display: flex;
  justify-content: center;
}

.el-form {
  width: 70%;
}

.end-text {
  margin-right: 20px;
  font-size: 15px;
}
</style>
